export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><path class=\"path\" d=\"M3.429 15.429H0V24h8.571v-3.429H3.43V15.43zM0 8.57h3.429V3.43H8.57V0H0v8.571zm20.571 12H15.43V24H24v-8.571h-3.429v5.142zM15.43 0v3.429h5.142V8.57H24V0h-8.571z\" fill=\"#000\" fill-rule=\"nonzero\"/></g>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};